import { IStatus } from "interfaces";

export const transferStatusColor = (status: IStatus['status']) => {
  switch (status) {
    case "TransferCancelled":
      return "#ED1C00";

    case "TransferFailed":
      return "#ED1C00";

    case "TransferAmlFailed":
      return "#ED1C00";

    case "PaymentFailed":
      return "#ED1C00";

    case "PaymentCancelled":
      return "#ED1C00";

    case "cancelled":
      return "#ED1C00";

    case "timedout":
      return "#ED1C00";

    case "TransferMade":
      return "#6FBE45";

    case "made":
      return "#6FBE45";

    case "PaymentMade":
      return "#6FBE45";

    case "confirmed":
      return "#6FBE45";

    case "PaymentConfirmed":
      return "#6FBE45";

    case "TransferComplete":
      return "#6FBE45";

    case "TransferReceivedFiatFunds":
      return "#F4A51D";

    case "TransferPending":
      return "#F4A51D";

    case "TransferStarted":
      return "#F4A51D";

    case "TransferReceivedCryptoFunds":
      return "#F4A51D";

    case "TransferWaitingForUserAction":
      return "#F4A51D";

    case "TransferSendingCryptoFunds":
      return "#F4A51D";

    case "pending":
      return "#F4A51D";

    case "incomplete":
      return "#F4A51D";

    default:
      break;
  }
};


export const readableStatus = (value: string) => {
  const mapValues: Record<string, string> = {
    PaymentConfirmed: "Payment Confirmed",
    TransferPending: "Transfer Pending",
    PaymentComplete: 'Payment Complete',
    PaymentCancelled: 'Payment Cancelled',
    cancelled: 'Cancelled',
    confirmed: 'Confirmed',
    incomplete: 'Incomplete',
    made: 'Made',
    paid: 'Paid',
    PaymentFailed: 'Payment Failed',
    PaymentMade: 'Payment Made',
    pending: 'Pending',
    timedout: 'Timedout',
    TransferCancelled: 'Transfer Cancelled',
    TransferComplete: 'Transfer Complete',
    TransferFailed: 'Transfer Failed',
    TransferMade: 'Transfer Made',
    TransferReceivedCryptoFunds: 'Transfer Received Crypto Funds',
    TransferReceivedFiatFunds: 'Transfer Received Fiat Funds',
    TransferStarted: 'Transfer Started',
    TransferWaitingForUserAction: 'Transfer Waiting For User Action',
    TransferSendingCryptoFunds: 'Transfer Sending Crypto Funds',
    TransferAmlFailed: 'Transfer Failed',
  };

  return mapValues[value];
};


// Payment Started -> Confirming Payment -> Sending Crypto -> Coin Delivered
// Payment Started -> Confirming Payment -> Sending Crypto -> Coin Delivered

// 1. Initiated Processing Delivering === Payment Made

// 2. Initiated Confirmed Delivering === Payment Confirmed

// 3. Initated Confirmed Delivered === Transfer Complete





// Initated Processing Delivered




// USING THIS
// Initiated -> Processing -> Delivering

// TransferNotfailed, PaymentNotCancelled, PaymentNotFailed, PaymentNotComplete - data.STATUS
// 
// Initiated = PaymentPending
// 
// 
// Processing = PaymentMade, but not PaymentConfirmed
// 
// Delivering = PaymentConfirmed and not TransferComplete
// 
// Delivered = TransferComplete
// 
// 
